'use strict';

import moment from 'moment';
import UTC from '@/common/UTC';

/**
 * Generate message for events and notifications by event
 * @param {object} event
 * @param {boolean} isDoctor
 * @returns {function}
 */
class generateEventMessage {
	constructor(event, isDoctor = false) {

	}

	static get(event) {
		let type = event.type;

		switch (true) {
			case /agenda\.patient\.\w+\.\w+$/.test(type):
				return this.patient(event)
			case /agenda\.root\.\w+\.\w+$/.test(type):
				return this.root(event)
			case /agenda\.personnel\.\w+\.\w+$/.test(type):
				return this.personnel(event)
			case /agenda\.client\.\w+\.\w+$/.test(type):
				return this.client(event)
			case /agenda\.root\.\w+\.\w+\.\w+\.\w+$/.test(type):
				return this.updateField(event)
			default:
				console.log('default', event.type)
				return 'Error 0';
		}
	}

	static patient(event) {
		return 'Вы были записаны на прием к врачу '
			+ this._initialsOfWorker(event.data.agenda.new.workers[0])
			+ ' на ' + this._convertTime(event.data.agenda.new.begin, 'YYYY-MM-DD HH:mm:ss')
	}

	static client(event) {
		let text = '';
		let who = event.type.match(/[a-z_]+$/)[0];

		if (who === 'patient') {
			text = 'Вы записались на прием к врачу ' + this._initialsOfWorker(event.data.agenda.new.workers[0]);
		} else if (who === 'doctor') {
			text = "К Вам записался на прием " + this._initials(event.data.agenda.new.users[0]);
		}

		return text + ' на ' + this._convertTime(event.data.agenda.new.begin, 'YYYY-MM-DD HH:mm:ss')
	}

	static root(event) {
		return 'Вы были записаны на прием к врачу '
			+ this._initialsOfWorker(event.data.agenda.new.workers[0])
			+ ' на ' + this._convertTime(event.data.agenda.new.begin, 'YYYY-MM-DD HH:mm:ss')
	}

	static personnel(event) {
		let text = '';
		let who = event.type.match(/[a-z_]+$/)[0];

		if (who === 'patient') {
			text = "Вас записали на прием к " + this._initialsOfWorker(event.data.agenda.new.workers[0]);
		} else if (who === 'doctor') {
			text = "Вы записали на прием пациента " + this._initials(event.data.agenda.new.users[0]);
		}

		return text + ' на ' + this._convertTime(event.data.agenda.new.begin, 'YYYY-MM-DD HH:mm:ss')
	}

	static updateField(event) {
		let text;
		let vars = event.type.match(/[a-z_]+/g);

		if(vars[4] === 'not_confirmed') {
			text = "У Вас визит "  + this._convertTime(event.data.agenda.new.begin, 'YYYY-MM-DD HH:mm:ss', 'DD.MM.YY') + " на " + this._convertTime(event.data.agenda.new.begin, 'YYYY-MM-DD HH:mm:ss', 'HH:mm') + ' у ' + this._initialsOfWorker(event.data.agenda.new.workers[0]) + '. Просим подтвердить!' ;
		} else if(vars[4] === 'not_appeared') {
			text = "Вы не появились на визит в " + this._convertTime(event.data.agenda.new.begin, 'YYYY-MM-DD HH:mm:ss');
		}

		return text
	}

	static _initials(human) {
		if (!human) return ''

		return human.last_name + ' ' + this._getFirstLetter(human.first_name) + '. ' + this._getFirstLetter(human.middle_name) + '.'
	}

	static _initialsOfWorker(human) {
		if (!human) return ''

		return human.user_last_name + ' ' + this._getFirstLetter(human.user_first_name) + '. ' + this._getFirstLetter(human.user_middle_name) + '.'
	}

	static _getFirstLetter(word) {
		return word[0].toUpperCase()
	}

	static _convertTime(time, from = 'X', to = 'DD.MM.YY HH:mm') {
		return moment(UTC.toLocal(time, from), from).format(to)
	}

}

export default generateEventMessage



// WEBPACK FOOTER //
// ./src/common/messageGenerator.js